import { render, staticRenderFns } from "./CreateSpectrumTaskButton.vue?vue&type=template&id=09dd3f99&"
import script from "./CreateSpectrumTaskButton.vue?vue&type=script&lang=js&"
export * from "./CreateSpectrumTaskButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports